/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/display-name */
import {
    Tooltip,
    Checkbox,
    makeStyles,
    TableContainer,
    TableHead,
    Table,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Collapse,
    Radio,
    FormControlLabel,
    SwipeableDrawer,
} from '@material-ui/core';
import { Theme, createStyles } from '@material-ui/core/styles';
import { GridRowData } from '@material-ui/data-grid';
import { useState, useEffect, useMemo } from 'react';
import React from 'react';
import en from '../../lang/en-us';
import { CheckBoxField } from '../CheckBoxField';
import SearchInput from '../SearchInput';
import Skeleton from '@material-ui/lab/Skeleton';
import {
    CustomToolTipProps,
    DataTableColumn as _Column,
    TableCellParams as CellParams,
    TableColumn as Column,
    TableProps,
} from './types';
import NoFoliosFound from '../../components/dashboard/makeNct/NoFoliosFound';
const { dashboard, common } = en;

export type TableColumn = Column;
export type DataTableColumn = _Column;
export type TableCellParams = CellParams;

const useStyles = makeStyles({
    tooltip: {
        backgroundColor: '#a39cc7',
        fontSize: 14,
    },
    arrow: {
        color: '#a39cc7',
    },
});

/**
 * Custoom Tool Tip
 * @param param0
 */

export function CustomToolTip({ children, ...props }: CustomToolTipProps) {
    const classes = useStyles();
    return (
        <Tooltip leaveTouchDelay={3000} enterTouchDelay={50} classes={classes} {...props}>
            {children}
        </Tooltip>
    );
}

/**
 * Custom Table with Collapse Feature and Radio selection & Checkbox Selection
 * @param param0 TableProps
 */

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
});

export function TableWithCollapse({
    rows,
    columns: _columns,
    radioGroupsEnabled = false,
    isCollapse = false,
    renderCollapse,
    checkBoxEnabled = false,
    toolTipDescription = '',
    selectedRows = [],
    setSelectedRows = () => { },
    disableAllSelection = false,
    filterType = null,
    filteredData = {},
    setFilterType = () => { },
    setFilteredData = () => { },
    isCheckBoxSelectable = true,
    resetFilters = () => { },
    enableSearch,
    notFoundMessage,
    ...props
}: TableProps) {
    const classes = useRowStyles();
    const columns = useMemo(() => _columns.filter((column) => !column.isFilter), [_columns]);
    const filterColumns = useMemo(
        () => _columns.filter((column) => !!column.filterBy || !!column.isFilter),
        [_columns],
    );
    const isRowsLoading = useMemo(() => columns.some((column) => !!column.Cell), [columns]);

    const MobileRow = ({ row, index }: { row: GridRowData; index: number }) => {
        const [collapse, setCollapse] = useState<boolean>(isCollapse);
        const isSelected = Boolean(selectedRows.find((_row) => _row.id === row.id));
        return (
            <div
                className={row.isDisabled ? `mobile-table-outer disabled` : 'mobile-table-outer'}
                onClick={_onRowSelected(row, !isSelected)}
                key={row.id}
            >
                {isRowsLoading ? (
                    <TableCell>
                        <Skeleton
                            height={18}
                            width={18}
                            variant={checkBoxEnabled ? 'rect' : 'circle'}
                        />
                    </TableCell>
                ) : (
                    <>
                        {checkBoxEnabled && (
                            <CustomToolTip
                                title={
                                    !!props.toolTipTextGetter &&
                                        typeof props.toolTipTextGetter === 'function'
                                        ? props.toolTipTextGetter({
                                            row,
                                            checked: isSelected,
                                        })
                                        : toolTipDescription
                                }
                                placement="right"
                            >
                                <span>
                                    <Checkbox
                                        checked={isSelected}
                                        disabled={row.isDisabled || !isCheckBoxSelectable}
                                    />
                                </span>
                            </CustomToolTip>
                        )}
                        {radioGroupsEnabled && (
                            <CustomToolTip
                                title={
                                    !!props.toolTipTextGetter &&
                                        typeof props.toolTipTextGetter === 'function'
                                        ? props.toolTipTextGetter({
                                            row,
                                            checked: isSelected,
                                        })
                                        : toolTipDescription
                                }
                                placement="right"
                            >
                                <span>
                                    <Radio
                                        disabled={row.isDisabled || !isCheckBoxSelectable}
                                        onChange={() => setSelectedRows([row])}
                                        checked={isSelected}
                                    />
                                </span>
                            </CustomToolTip>
                        )}
                    </>
                )}
                <div className="mobile-table-content">
                    {columns.map(
                        (
                            { renderCell, field, valueGetter, Cell, fullWidth = false, ...column },
                            _index,
                        ) => {
                            const value = row[`${field}`];
                            const GridParams: TableCellParams = {
                                row,
                                id: row.id,
                                value,
                                colDef: { field, ...column },
                                setCollapse,
                                collapse,
                                index,
                            };
                            return (
                                <div
                                    key={`${index + _index}`}
                                    className={`mobile-table-info ${_index === 0 ? 'mobile-table-straight' : ''
                                        } ${field === 'amcName' || fullWidth ? 'mobile-table-full' : ''
                                        }`}
                                >
                                    <p className="label">{column.headerName}</p>
                                    <p className="value">
                                        {Cell
                                            ? Cell
                                            : renderCell
                                                ? renderCell(GridParams)
                                                : valueGetter
                                                    ? valueGetter(GridParams)
                                                    : value}
                                    </p>
                                </div>
                            );
                        },
                    )}
                    <div className="mobile-table-collapse-outer">
                        <Collapse
                            in={collapse}
                            timeout="auto"
                            unmountOnExit
                            style={{ padding: '13px 20px' }}
                        >
                            {renderCollapse ? (
                                <div className="mobile-table-collapse">
                                    {renderCollapse({ row, setCollapse })}
                                </div>
                            ) : (
                                <React.Fragment />
                            )}
                        </Collapse>
                    </div>
                </div>
            </div>
        );
    };
    const DataRow = ({ row, index }: { row: GridRowData; index: number }) => {
        const [collapse, setCollapse] = useState<boolean>(isCollapse);
        const isSelected = Boolean(selectedRows.find((_row) => _row.id === row.id));
        const renderRow = useMemo(() => {
            return columns.map(
                ({ renderCell, field, valueGetter, Cell, ...column }, _index: number) => {
                    const value = row[`${field}`];
                    const GridParams: TableCellParams = {
                        row,
                        id: row.id,
                        value,
                        colDef: { field, ...column },
                        setCollapse,
                        index,
                        collapse,
                    };
                    return Cell ? (
                        <TableCell className={column.className} key={field + index + _index}>
                            {Cell}
                        </TableCell>
                    ) : renderCell ? (
                        <TableCell className={column.className} key={field + index + _index}>
                            {renderCell(GridParams)}
                        </TableCell>
                    ) : (
                        <TableCell className={column.className} key={field + index + _index}>
                            {valueGetter ? valueGetter(GridParams) : value}
                        </TableCell>
                    );
                },
            );
        }, [row, collapse, index]);
        return (
            <>
                <TableRow className={`${classes.root} ${row.isDisabled ? 'disabledCell' : ''}`}>
                    {(radioGroupsEnabled || checkBoxEnabled) &&
                        (isRowsLoading ? (
                            <TableCell>
                                <Skeleton
                                    height={18}
                                    width={18}
                                    variant={checkBoxEnabled ? 'rect' : 'circle'}
                                />
                            </TableCell>
                        ) : (
                            <TableCell>
                                {checkBoxEnabled ? (
                                    props.toolTipEnabled ? (
                                        <CustomToolTip
                                            title={
                                                !!props.toolTipTextGetter &&
                                                    typeof props.toolTipTextGetter === 'function'
                                                    ? props.toolTipTextGetter({
                                                        row,
                                                        checked: isSelected,
                                                    })
                                                    : toolTipDescription
                                            }
                                            placement="right"
                                        >
                                            <span>
                                                <Checkbox
                                                    onChange={_onRowSelected(row, !isSelected)}
                                                    checked={isSelected}
                                                    disabled={
                                                        row.isDisabled || !isCheckBoxSelectable
                                                    }
                                                />
                                            </span>
                                        </CustomToolTip>
                                    ) : (
                                        <Checkbox
                                            disabled={row.isDisabled || !isCheckBoxSelectable}
                                            onChange={_onRowSelected(row, !isSelected)}
                                            checked={isSelected}
                                        />
                                    )
                                ) : props.toolTipEnabled ? (
                                    <CustomToolTip
                                        title={
                                            !!props.toolTipTextGetter &&
                                                typeof props.toolTipTextGetter === 'function'
                                                ? props.toolTipTextGetter({
                                                    row,
                                                    checked: isSelected,
                                                })
                                                : toolTipDescription
                                        }
                                        placement="right"
                                    >
                                        <span>
                                            <Radio
                                                onChange={() => setSelectedRows([row])}
                                                checked={isSelected}
                                                disabled={row.isDisabled || !isCheckBoxSelectable}
                                            />
                                        </span>
                                    </CustomToolTip>
                                ) : (
                                    <Radio
                                        onChange={() => setSelectedRows([row])}
                                        checked={isSelected}
                                        disabled={row.isDisabled || !isCheckBoxSelectable}
                                    />
                                )}
                            </TableCell>
                        ))}
                    {renderRow}
                </TableRow>
                {useMemo(
                    () => (
                        <TableRow>
                            <TableCell
                                className="collapsible-row"
                                style={{ padding: !collapse ? '0' : '0 20px 20px' }}
                                colSpan={columns.length + 1}
                            >
                                <Collapse
                                    in={collapse}
                                    timeout="auto"
                                    unmountOnExit
                                    style={{ padding: '13px 20px' }}
                                >
                                    {renderCollapse ? (
                                        renderCollapse({ row, setCollapse })
                                    ) : (
                                        <div></div>
                                    )}
                                </Collapse>
                            </TableCell>
                        </TableRow>
                    ),
                    [collapse, setCollapse, renderCollapse, columns, row],
                )}
            </>
        );
    };

    const _onRowSelected = (row: GridRowData, checked: boolean) => (e: any) => {
        if (row.isDisabled) return;
        if (radioGroupsEnabled) {
            setSelectedRows([row]);
            return;
        }
        const isSelectable =
            !!props.isRowSelectable && typeof props.isRowSelectable === 'function'
                ? props.isRowSelectable({ row, checked })
                : true;
        if (isSelectable) {
            setSelectedRows((prev: GridRowData[]) => {
                return checked
                    ? [...prev, row]
                    : prev.filter((_row: GridRowData) => _row.id !== row.id);
            });
        }
    };

    const _onColumnHeaderClick = (isAllSelected: boolean) => {
        if (!isCheckBoxSelectable) return;
      setSelectedRows(() =>
            isAllSelected
                ? rows.filter((row) => !row.isDisabled && !row.isExcludeFromSelectAll)
                : [],
        );
        if (!!props.onColumnHeaderClick && typeof props.onColumnHeaderClick === 'function') {
            props.onColumnHeaderClick({ isSelected: isAllSelected });
        }
    };

    const SelectAllCheckBox = () => {
        const selectableCount = filteredRows.filter(
            (row) => !row.isDisabled && !row.isExcludeFromSelectAll,
        ).length;
        const isAllSelected = selectableCount > 0 && selectedRows.length === selectableCount;
        return (
            <Checkbox
                checked={isAllSelected}
                indeterminate={selectedRows.length > 0 && selectedRows.length < selectableCount}
                onChange={() => _onColumnHeaderClick(!isAllSelected)}
                disabled={!rows.filter((row) => !row.isDisabled).length}
            />
        );
    };

    const MobileSelectAll = () => {
        return (
            <div className="mobile-table-selectAll">
                <FormControlLabel control={<SelectAllCheckBox />} label="Select All" />
            </div>
        );
    };

    const filteredRows = useMemo(() => {
        const filterKeys = Object.keys(filteredData).filter((key) => key !== 'searchKey');
        const filtredRowData = rows.reduce((prev: GridRowData[], currRow) => {
            const valid = filterKeys.every((_key) => {
                const _filterData = filteredData[_key] || [];
                const value =
                    typeof currRow[_key] === 'string'
                        ? currRow[_key]?.toString()?.toLowerCase()
                        : currRow[_key];
                if (!_filterData.length) {
                    return true;
                }
                if (_key === 'assetType') {
                    let other = false;
                    let assetTypes = typeof value === 'string' ? [value?.toUpperCase()] : value; // Modifying assetTypes as array
                    if (_filterData.includes('other')) {
                        other = assetTypes?.every((assetType: string) => {
                            const _assetType = assetType?.toUpperCase();
                            return !(
                                _assetType === 'EQUITY' ||
                                _assetType === 'DEBT' ||
                                _assetType === 'LIQUID'
                            );
                        });
                    }
                    return (
                        _filterData.some((_assetType: string) =>
                            assetTypes?.includes(_assetType?.toUpperCase()),
                        ) || other
                    );
                }
                if (_filterData.includes(value)) {
                    return true;
                }
            });
            if (valid) {
                return [...prev, currRow];
            }
            return prev;
        }, []);

        return filteredData.searchKey
            ? filtredRowData.filter((row) =>
                row?.amcName?.toLowerCase()?.includes(filteredData?.searchKey?.toLowerCase()),
            )
            : filtredRowData;
    }, [rows, filteredData]);
    const _TableFilters = useMemo(
        () => (
            <TableFilters
                rows={rows}
                columns={filterColumns}
                filteredData={filteredData}
                filterType={filterType}
                setFilterType={setFilterType}
                setFilteredData={setFilteredData}
                resetFilters={resetFilters}
                enableSearch={enableSearch}
            />
        ),
        [
            rows,
            filterColumns,
            filteredData,
            filterType,
            setFilterType,
            setFilteredData,
            resetFilters,
        ],
    );

    return (
        <div className="curved-table-content" style={{ width: '100%' }}>
            {filterColumns.length ? _TableFilters : <React.Fragment />}
            <div className="curved-table-content-bottom" style={{ width: '100%' }}>
                {!!filteredRows.length ? (
                    <TableContainer style={{ maxHeight: 400 }} component={Paper}>
                        <Table aria-label="collapsible-table" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {radioGroupsEnabled && <TableCell></TableCell>}
                                    {checkBoxEnabled && !disableAllSelection && (
                                        <TableCell>
                                            <SelectAllCheckBox />
                                        </TableCell>
                                    )}
                                    {checkBoxEnabled && disableAllSelection && (
                                        <TableCell></TableCell>
                                    )}
                                    {columns.map((header: TableColumn, _index: number) => (
                                        <TableCell
                                            style={{
                                                minWidth: header.width,
                                            }}
                                            key={_index}
                                        >
                                            {header.headerName}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredRows.map((row: any, index: number) => (
                                    <DataRow key={index} row={row} index={index} />
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <NoFoliosFound info={notFoundMessage || common.noFoliosFound} />
                )}
                {checkBoxEnabled && !disableAllSelection && <MobileSelectAll />}
                <div className="mobile-table">
                    {filteredRows.map((row, index) => (
                        <MobileRow key={index} row={row} index={index} />
                    ))}
                </div>
            </div>
        </div>
    );
}

/**
 *  Filter For The table
 * @param columns
 * @param rows
 * @param onUpdateFilters
 */
export function TableFilters({
    columns = [],
    rows = [],
    filterType = null,
    filteredData = {},
    setFilteredData = () => { },
    setFilterType = () => { },
    resetFilters,
    enableSearch = true,
}: {
    columns: TableColumn[];
    rows: GridRowData[];
    setFilterType: Function;
    setFilteredData: Function;
    filterType: string | null;
    filteredData: any;
    resetFilters: Function;
    enableSearch?: boolean;
}) {
    const [openDrawer, setDrawer] = useState<boolean>(false);

    const _handleChange = (fieldKey: string, _ele: string) => {
        const fieldData = filteredData[fieldKey] || [];
        const index = fieldData.findIndex((ele: any) => ele === _ele);
        const _filteredData =
            index === -1
                ? {
                    ...filteredData,
                    [fieldKey]: [...fieldData, _ele],
                }
                : {
                    ...filteredData,
                    [fieldKey]: fieldData.filter((ele: any) => ele !== _ele),
                };
        setFilteredData(_filteredData);
    };

    const Filters = useMemo(() => {
        return columns.map((column, index) => (
            <a
                key={index}
                onClick={() => {
                    setDrawer(true);
                    setFilterType((type: string) =>
                        type === (column.filterKey || column.field)
                            ? ''
                            : column.filterKey || column.field,
                    );
                }}
                className={
                    filterType === (column.filterKey || column.field) && openDrawer ? 'active' : ''
                }
            >
                <img className="mobile_mode" src="/images/filters.svg" alt="icon" />
                <span>
                    {column.filterHeader || column.headerName}
                    <img
                        src={
                            filterType === (column.filterKey || column.field) && openDrawer
                                ? '/images/up-arrow-purple.svg'
                                : '/images/down-arrow-black.svg'
                        }
                        alt="icon"
                    />
                </span>
            </a>
        ));
    }, [columns, filterType, setFilterType, openDrawer]);

    const onRemoveFilter = (field: string, ele: string) => () => {
        const fieldData: string[] = filteredData[field];
        const _filterData = {
            ...filteredData,
            [field]: fieldData.filter((_ele: string) => _ele !== ele),
        };
        setFilteredData(_filterData);
    };

    const FilterChips = () => {
        return Object.keys(filteredData)
            .filter((key) => key !== 'searchKey')
            .map((_key: string, _index: number) =>
                filteredData[_key].map((_ele: string, _index1: number) => (
                    <span key={_index + _index1}>
                        {_ele}
                        <img
                            src="/images/close-black.svg"
                            alt="icon"
                            onClick={onRemoveFilter(_key, _ele)}
                        />
                    </span>
                )),
            );
    };

    const onClear = () => {
        resetFilters();
    };

    return (
        <div className="curved-table-content-filters">
            <div className="curved-table-content-top">
                <p className="desktop_mode">
                    <img src="/images/filters.svg" alt="icon" />
                    {dashboard.ChangeDividend.filters} :
                </p>
                {Filters}
                {enableSearch && (
                    <SearchInput
                        darkmode={true}
                        placeholder={dashboard.ChangeDividend.searchByAMC}
                        value={filteredData['searchKey'] || ''}
                        onChange={(e: any) =>
                            setFilteredData({ ...filteredData, searchKey: e.target.value })
                        }
                    />
                )}
            </div>
            {columns.map((column, index) => {
                const fieldKey = column.filterKey || column.field;
                const dataWithDuplicatedValueKeys = rows.map((row) => row[fieldKey]);
                const data = dataWithDuplicatedValueKeys.reduce((prev, curr) => {
                    if (!prev.includes(curr)) {
                        return [...prev, curr];
                    }
                    return prev;
                }, []);
                const values = column.renderStaticFilters?.length
                    ? column.renderStaticFilters
                    : data;
                return (
                    <>
                        <Collapse key={index} in={filterType === fieldKey} className="desktop_mode">
                            <div className="curved-table-filters-dropdown">
                                <div className="curved-table-filters-dropdown-inner">
                                    {values.map((_ele: string, index: number) => (
                                        <CheckBoxField
                                            key={index}
                                            label={_ele}
                                            onChange={() =>
                                                _handleChange(
                                                    fieldKey,
                                                    _ele?.toString()?.toLowerCase(),
                                                )
                                            }
                                            value={(filteredData[fieldKey] || [])?.includes(
                                                _ele?.toString()?.toLowerCase(),
                                            )}
                                        />
                                    ))}
                                </div>
                            </div>
                        </Collapse>
                        <SwipeableDrawer
                            anchor={'bottom'}
                            open={filterType === (column.filterKey || column.field) && openDrawer}
                            onClose={() => {
                                setFilterType('');
                                setDrawer(false);
                            }}
                            onOpen={() => { }}
                            className="mobile_mode"
                        >
                            <div className="curved-table-filters-dropdown">
                                <div className="curved-table-filters-dropdown-inner">
                                    {values.map((_ele: string, index: number) => (
                                        <CheckBoxField
                                            key={index}
                                            label={_ele}
                                            onChange={() =>
                                                _handleChange(
                                                    fieldKey,
                                                    _ele?.toString()?.toLowerCase(),
                                                )
                                            }
                                            value={(filteredData[fieldKey] || [])?.includes(
                                                _ele?.toString()?.toLowerCase(),
                                            )}
                                        />
                                    ))}
                                </div>
                            </div>
                        </SwipeableDrawer>
                    </>
                );
            })}
            {!!Object.keys(filteredData)
                .filter((key: string) => key !== 'searchKey')
                .some((_ele: any) => !!filteredData[_ele].length) && (
                    <div className="curved-table-filters-selected">
                        <div className="curved-table-filters-selected-tags">
                            {Object.keys(filteredData).length ? (
                                <p>{dashboard.ChangeDividend.selectedFilters}</p>
                            ) : (
                                <React.Fragment />
                            )}
                            <div className="tags">{FilterChips()}</div>
                        </div>
                        {Object.keys(filteredData).length ? (
                            <div className="curved-table-filters-remove">
                                <a onClick={onClear}>{dashboard.ChangeDividend.removeFilter}</a>
                            </div>
                        ) : (
                            <React.Fragment />
                        )}
                    </div>
                )}
        </div>
    );
}
